import { useTranslation } from "react-i18next";
import { SubscribeButton } from "@/components/subscribe-button";
import { RouterLink } from "@/components";
import { Paths } from "@/features/subscriptions";
import { PaymentMethod, useAuth } from "@/features/auth";
import { pushToDataLayer } from "@/data-layer/push-to-data-layer";

const SubscribeButtonNavigation = () => {
  const { t } = useTranslation("coi-platform-translations");
  const { user, accountDetails, isUserPermitted } = useAuth();

  if (!user) return null;

  const isFreePlanUser = user.payment_method === PaymentMethod.Free;
  const isUserAuthorizedToManageSubscription = isUserPermitted(["SUBSCRIPTION_EDIT"]);

  const handleClick = () => {
    pushToDataLayer("subscribeButtonClick", {
      placement: "navigation",
    });
  };

  if (!isUserAuthorizedToManageSubscription || !accountDetails?.capabilities?.isSubscriptionButtonAvailable)
    return null;

  if (isFreePlanUser) {
    return <SubscribeButton onClick={handleClick} />;
  }

  return (
    <RouterLink.Button data-testid="start-subscription" onClick={handleClick} to={Paths.Root} variant="outlined">
      {t("navigation.subscription_button")}
    </RouterLink.Button>
  );
};

export default SubscribeButtonNavigation;
